import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";
import { XIcon, CheckIcon } from "@heroicons/vue/solid";

interface WhiseDetail {
    id: number;
    label: string;
    type: "year" | "yes/no" | "length" | "environment" | "heating" | "kitchen" | "ground_destination" | "ElecCertifConformity" | "float" | "char";
    value: string;
    group: string;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    details: { type: Array, required: true }
  },
  setup(__props: any, { expose }) {
  expose();

const props = __props as { details: WhiseDetail[] }



const displayGroup: string[] = ["Juridisch", "Energie", "Certificaten", "Omgeving"];

const filteredDetails = computed(() => {
    return props.details
        .filter((d: WhiseDetail) => displayGroup.includes(d.group))
        .reduce((d: { [key: string]: WhiseDetail[] }, wDetail) => {
            const { group } = wDetail;
            d[group] = d[group] ?? [];
            d[group].push(wDetail);
            return d;
        }, {});
});

const __returned__ = { props, displayGroup, filteredDetails, XIcon, CheckIcon }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})